<template>
  <div>
    <!-- <a-layout-sider
    :class="['sider', isDesktop() ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null ]"
    width="206px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null">
    <logo :title="siteTitle" :style="{ position:'fixed',zIndex:'100',width:width }"/>
    <s-menu
      :collapsed="collapsed"
      :menu="menus"
      :theme="theme"
      mode="inline"
      @select="onSelect"
      style="padding: 16px 0px;margin-top:60px"></s-menu>
  </a-layout-sider> -->
  </div>
</template>

<script>
import Logo from '@/components/tools/Logo'
import SMenu from './index'
import { mixin, mixinDevice } from '@/utils/mixin'

export default {
  name: 'SideMenu',
  components: { Logo, SMenu },
  mixins: [mixin, mixinDevice],
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline',
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menus: {
      type: Array,
      required: true,
    },
    width: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      siteTitle: process.env.VUE_APP_SIDE_MENU_TITLE,
    }
  },
  methods: {
    onSelect(obj) {
      this.$emit('menuSelect', obj)
    },
  },
}
</script>
